import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import Testimonial from "../Components/Testimonial";
import Footer from "../Components/Footer";
import Blogcontent from "./Blogcontent";
import { CartProvider } from "react-use-cart";
function Blog() {
  return (
    <CartProvider>
      <Navbar />
      <Hero value={<h1>Blog</h1>} />
      <Blogcontent />
      <Testimonial />
      <Footer />
    </CartProvider>
  );
}

export default Blog;
